import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/styles/app.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/contextApi';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
       <AuthProvider>
           <App />
       </AuthProvider>
    
  </React.StrictMode>
);

reportWebVitals();
